export const getLinkedProviders = (state) => state.providers.linked;

export const getQueryProviders = (state, searchQueryProviders) => {
    const linkedProviders = getLinkedProviders(state);
    const newsrooms = searchQueryProviders?.includes('all') ? linkedProviders.join(',') : searchQueryProviders;
    return newsrooms;
};
